module.exports = __webpack_public_path__ + "h5/img/cygn16.3441627f.png";